import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setApiErrorData, setOpenNoInternetModal } from "redux/action";

const useClearApiErrorData = () => {
  const dispatch = useDispatch();
  const apiErrors = useSelector((state) => state.rootReducer.apiErrors);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!apiErrors?.isOpen && apiErrors?.apis?.length) {
        const filtered = apiErrors.apis.filter(
          (it) => Date.now() - (it?.time || 0) < 60000
        );

        if (filtered.length !== apiErrors.apis.length) {
          dispatch(setApiErrorData(filtered));
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [dispatch]); // ❗ KHÔNG cho apiErrors vào đây

  useEffect(() => {
    const handleUnload = () => {
      dispatch(setOpenNoInternetModal(false));
    };

    window.addEventListener("unload", handleUnload);
    return () => window.removeEventListener("unload", handleUnload);
  }, [dispatch]);
};

export default useClearApiErrorData;
